import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { SupplierAgreementResource } from "@exonn/js-sdk";
import { AgreementPrices } from "src/admin/modules/supplier-agreement/forms/supplier-agreement/tabs/prices/AgreementPrices.tsx";

// Produktvereinbarungen: пункт меню «Einkauf», вкладки «Lieferanten» у товара и «Artikel» у поставщика.
export const module: ModuleOptions<SupplierAgreementResource> = {
  resource: ResourceEnum.SupplierAgreement,
  // Вкладка Preisstaffeln читает данные соглашения из контекста формы.
  layoutForm: true,
  bigIcon: <i className="icon-20-suppliers" />,
  smallIcon: <i className="icon-15-suppliers" />,

  tabs: {
    edit: {
      includes: ["variant"],
      getTitle: (resource, t) =>
        [
          resource.variant?.sku,
          resource.procurement_type &&
            t(`procurement-type.${resource.procurement_type}`),
        ]
          .filter(Boolean)
          .join(" · "),
    },
  },

  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    prices: {
      title: (t) => t("formTabs.prices.title"),
      routeObject: {
        Component: AgreementPrices,
      },
      isHidden: ({ data }) => !data?.id,
    },
  },
};
